// VUEX STATE: notification
// ------------------------------------

const state = {
  notificationList: []

}

export default state